// extracted by mini-css-extract-plugin
module.exports = {"bgColor":"#fecc00","bgColorBlue":"#04355f","fontColorPrimary":"#04355f","fontColorSecondary":"#F7F7F9","defaultBorderRadius":".25rem"};